// Converts a Web Audio clock time to wall-clock epoch ms, the clock the hub and
// agents schedule with. Uses the output timestamp when available, so the
// result is when the sound is actually heard (output latency included).
export function audioTimeToEpochMs(ctx: AudioContext, audioTime: number): number {
  const wallMinusPerf = Date.now() - performance.now();
  const ts = ctx.getOutputTimestamp?.();
  if (ts && ts.contextTime !== undefined && ts.performanceTime) {
    return ts.performanceTime + (audioTime - ts.contextTime) * 1000 + wallMinusPerf;
  }
  const latency = ctx.outputLatency || ctx.baseLatency || 0;
  return Date.now() + (audioTime - ctx.currentTime + latency) * 1000;
}
